// Native
import { useEffect, useState } from "react"
import { useParams } from "react-router"

// Components
import { ButtonGroup, Grid, GridItem, HStack, Stat, StatHelpText, StatLabel, StatNumber } from "@chakra-ui/react"
import { Form, IconButton, Section } from "components"
import SalesChart from "./salesChart"

// Config
import { Moment } from "config"

// Hooks
import { useProduct, useProductReport } from "hooks"

export default function General(){

    const params = useParams()
    const product = useProduct(params?.id)
    const initial = [Moment().subtract('months', 3).toDate(), Moment().toDate()]
    const [ period, setPeriod ] = useState(initial)
    const report = useProductReport(params?.id, period)

    useEffect(() => {
        report.refetch()
    }, [period])

    return(
    <>
    <Section title="Visão geral">

        <HStack>
            <Form.Interval label="Selecione o período:" initial={initial} onSelect={setPeriod} />
        
            <ButtonGroup size="xs">
                <IconButton label="Atualizar" icon="refresh" isLoading={report.isFetching} onClick={report.refetch} />
            </ButtonGroup>
        </HStack>
    </Section>

    <Grid templateColumns="33% 33% 33%" gap={8} mb={8}>
        <GridItem>
            <Stat>
                <StatLabel>Estoque da matriz</StatLabel>
                <StatNumber>{report.data?.matriz_stock?.stock}</StatNumber>
                <StatHelpText>{report.data?.matriz_stock?.reserved} estão reservados</StatHelpText>
            </Stat>
        </GridItem>

        <GridItem>
            <Stat>
                <StatLabel>Estoque de núcleos</StatLabel>
                <StatNumber>{report.data?.distributors_stock?.stock}</StatNumber>
                <StatHelpText>{report.data?.distributors_stock?.reserved} estão reservados</StatHelpText>
            </Stat>
        </GridItem>
    </Grid>

    <Grid templateColumns="49% 49%" gap={8} mb={8}>
        <GridItem><SalesChart data={report.data?.sales_matriz_daily_growth} title="Vendas da matriz" /></GridItem>
        <GridItem><SalesChart data={report.data?.sales_distributors_daily_growth} title="Vendas de núcleos" /></GridItem>
    </Grid>

    
    </>
    )
}